export enum EditEnvironmentActions{
    AddServer = "Add Server(s)",
    ReviewPurchase = "Review"
}